import React, { Component } from 'react';
import { Button } from '../ui';
import { MapPinIcon, CalendarIcon, UsersIcon, CheckCircle2Icon, LayoutDashboardIcon, ClockIcon, UsersRoundIcon, FileTextIcon, SparklesIcon, TrendingUpIcon, PlusIcon, TargetIcon, HeartPulseIcon, ActivityIcon, UtensilsIcon, MessageSquareIcon, BarChart3Icon, ExternalLinkIcon } from 'lucide-react';
export function DashboardHome() {
  return <div className="space-y-6" data-id="element-1149">
      {/* Event Header Card */}
      <div className="bg-white rounded-2xl shadow-soft p-6 md:p-8 border border-slate-100" data-id="element-1150">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6" data-id="element-1151">
          <div data-id="element-1152">
            <h1 className="text-3xl font-bold text-brand-navy mb-3" data-id="element-1153">
              Leadership Reset Retreat
            </h1>
            <div className="flex flex-wrap items-center gap-4 text-sm text-slate-600" data-id="element-1154">
              <div className="flex items-center gap-2" data-id="element-1155">
                <MapPinIcon className="w-4 h-4 text-brand-teal" data-id="element-1156" />
                <span data-id="element-1157">Punta Cana</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1158">
                <CalendarIcon className="w-4 h-4 text-brand-teal" data-id="element-1159" />
                <span data-id="element-1160">May 12–14, 2026</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1161">
                <UsersIcon className="w-4 h-4 text-brand-teal" data-id="element-1162" />
                <span data-id="element-1163">48 attendees</span>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3" data-id="element-1164">
            <span className="bg-amber-50 text-amber-700 text-xs font-bold px-3 py-1.5 rounded-full" data-id="element-1165">
              Pre-Event
            </span>
            <div className="flex gap-2" data-id="element-1166">
              <Button variant="outline" size="sm" href="/event-hub" data-id="element-1167">
                Preview Participant View
              </Button>
              <Button variant="accent" size="sm" href="/event-hub" data-id="element-1168">
                Launch Event Hub
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Top Metrics */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-1169">
        <MetricCard icon={<CheckCircle2Icon className="w-5 h-5" data-id="element-1171" />} label="Intake Completion" value="86%" progress={86} color="teal" data-id="element-1170" />
        <MetricCard icon={<LayoutDashboardIcon className="w-5 h-5" data-id="element-1173" />} label="Event Hub Activation" value="74%" progress={74} color="coral" data-id="element-1172" />
        <MetricCard icon={<ClockIcon className="w-5 h-5" data-id="element-1175" />} label="Agenda Readiness" value="92%" progress={92} color="teal" data-id="element-1174" />
        <MetricCard icon={<UsersRoundIcon className="w-5 h-5" data-id="element-1177" />} label="Group Matching" value="Ready" status="success" data-id="element-1176" />
        <MetricCard icon={<FileTextIcon className="w-5 h-5" data-id="element-1179" />} label="Report Readiness" value="In progress" status="warning" data-id="element-1178" />
      </div>

      {/* Main Grid */}
      <div className="grid lg:grid-cols-3 gap-6" data-id="element-1180">
        {/* Left Column - 2/3 width */}
        <div className="lg:col-span-2 space-y-6" data-id="element-1181">
          {/* Event Setup Checklist */}
          <div className="bg-white rounded-2xl shadow-soft p-6 border border-slate-100" data-id="element-1182">
            <div className="flex items-center justify-between mb-6" data-id="element-1183">
              <h2 className="text-xl font-bold text-brand-navy" data-id="element-1184">
                Event Setup Checklist
              </h2>
              <span className="text-sm font-medium text-slate-500" data-id="element-1185">
                6 of 8 complete
              </span>
            </div>
            <div className="space-y-3" data-id="element-1186">
              <ChecklistItem label="Create event" completed data-id="element-1187" />
              <ChecklistItem label="Configure intake form" completed data-id="element-1188" />
              <ChecklistItem label="Add agenda" completed data-id="element-1189" />
              <ChecklistItem label="Select learning pathway" completed data-id="element-1190" />
              <ChecklistItem label="Set wellness preferences" completed data-id="element-1191" />
              <ChecklistItem label="Invite attendees" completed data-id="element-1192" />
              <ChecklistItem label="Create groups" inProgress data-id="element-1193" />
              <ChecklistItem label="Launch survey" data-id="element-1194" />
            </div>
            <div className="mt-4 pt-4 border-t border-slate-100" data-id="element-1195">
              <div className="flex items-center gap-3" data-id="element-1196">
                <div className="flex-1 bg-slate-100 rounded-full h-2" data-id="element-1197">
                  <div className="bg-brand-teal h-2 rounded-full w-[75%]" data-id="element-1198"></div>
                </div>
                <span className="text-sm font-bold text-brand-navy" data-id="element-1199">75%</span>
              </div>
            </div>
          </div>

          {/* Agenda Builder */}
          <div className="bg-white rounded-2xl shadow-soft p-6 border border-slate-100" data-id="element-1200">
            <div className="flex items-center justify-between mb-6" data-id="element-1201">
              <h2 className="text-xl font-bold text-brand-navy" data-id="element-1202">
                Agenda Builder
              </h2>
              <Button variant="ghost" size="sm" data-id="element-1203">
                Edit Agenda
              </Button>
            </div>
            <div className="grid md:grid-cols-4 gap-4" data-id="element-1204">
              <AgendaColumn title="Before Arrival" color="slate" items={[{
              time: '',
              label: 'Complete intake form'
            }, {
              time: '',
              label: 'Review participant intros'
            }, {
              time: '',
              label: 'Set personal goals'
            }]} data-id="element-1205" />
              <AgendaColumn title="Day 1" color="teal" items={[{
              time: '9:00',
              label: 'Welcome circle'
            }, {
              time: '10:30',
              label: 'Team Trust workshop'
            }, {
              time: '14:00',
              label: 'Wellness break'
            }]} data-id="element-1206" />
              <AgendaColumn title="Day 2" color="coral" items={[{
              time: '8:00',
              label: 'Morning activities'
            }, {
              time: '10:00',
              label: 'Leadership Reset module'
            }, {
              time: '15:00',
              label: 'Group reflection'
            }]} data-id="element-1207" />
              <AgendaColumn title="After Event" color="navy" items={[{
              time: '',
              label: 'Post-event survey'
            }, {
              time: '',
              label: 'Commitment tracking'
            }, {
              time: '',
              label: '30-day check-in'
            }]} data-id="element-1208" />
            </div>
          </div>

          {/* Learning Pathway Builder */}
          <div className="bg-white rounded-2xl shadow-soft p-6 border border-slate-100" data-id="element-1209">
            <div className="flex items-center justify-between mb-6" data-id="element-1210">
              <h2 className="text-xl font-bold text-brand-navy" data-id="element-1211">
                Learning Pathway Builder
              </h2>
              <Button variant="ghost" size="sm" data-id="element-1212">
                Customize
              </Button>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1213">
              <ModuleCard title="Leadership Reset" active tags={['Prompts', 'Pair exercise', 'Commitment']} data-id="element-1214" />
              <ModuleCard title="Team Trust" tags={['Prompts', 'Group exercise']} data-id="element-1215" />
              <ModuleCard title="Wellness and Energy" tags={['Prompts', 'Activities']} data-id="element-1216" />
              <ModuleCard title="Communication Under Pressure" tags={['Pair exercise', 'Commitment']} data-id="element-1217" />
              <ModuleCard title="Customer Excellence" tags={['Group exercise', 'Reflection']} data-id="element-1218" />
            </div>
          </div>

          {/* Group Matching */}
          <div className="bg-white rounded-2xl shadow-soft p-6 border border-slate-100" data-id="element-1219">
            <div className="flex items-center justify-between mb-6" data-id="element-1220">
              <h2 className="text-xl font-bold text-brand-navy" data-id="element-1221">
                Group Matching
              </h2>
              <Button variant="ghost" size="sm" data-id="element-1222">
                View All
              </Button>
            </div>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-1223">
              <GroupCard title="Buddy Pairs" count="24 pairs" avatars={6} data-id="element-1224" />
              <GroupCard title="Small Groups" count="8 groups of 6" avatars={6} data-id="element-1225" />
              <GroupCard title="Discussion Pods" count="6 pods" avatars={8} data-id="element-1226" />
              <GroupCard title="Activity Groups" count="5 groups" avatars={5} data-id="element-1227" />
            </div>
          </div>

          {/* Survey Builder */}
          <div className="bg-white rounded-2xl shadow-soft p-6 border border-slate-100" data-id="element-1228">
            <div className="flex items-center justify-between mb-6" data-id="element-1229">
              <h2 className="text-xl font-bold text-brand-navy" data-id="element-1230">
                Survey Builder
              </h2>
              <Button variant="ghost" size="sm" data-id="element-1231">
                Create Survey
              </Button>
            </div>
            <div className="space-y-3" data-id="element-1232">
              <SurveyRow title="Pre-event survey" status="Sent" statusColor="teal" data-id="element-1233" />
              <SurveyRow title="Daily reflection" status="Active" statusColor="coral" data-id="element-1234" />
              <SurveyRow title="Post-event survey" status="Scheduled" statusColor="amber" data-id="element-1235" />
              <SurveyRow title="30-day accountability" status="Scheduled" statusColor="slate" data-id="element-1236" />
            </div>
          </div>
        </div>

        {/* Right Column - 1/3 width */}
        <div className="space-y-6" data-id="element-1237">
          {/* AI Recommendations */}
          <div className="bg-brand-navy rounded-2xl shadow-soft p-6 text-white" data-id="element-1238">
            <div className="flex items-center gap-2 mb-6" data-id="element-1239">
              <SparklesIcon className="w-5 h-5 text-brand-coral" data-id="element-1240" />
              <h2 className="text-lg font-bold" data-id="element-1241">AI Recommendations</h2>
            </div>
            <div className="space-y-3" data-id="element-1242">
              <AIRecommendation text="Add Team Trust module" action="Add" data-id="element-1243" />
              <AIRecommendation text="Create buddy pairs" action="Create" data-id="element-1244" />
              <AIRecommendation text="Add wellness check-in on Day 2" action="Schedule" data-id="element-1245" />
              <AIRecommendation text="Ask attendees about food/alcohol preferences" action="Add" data-id="element-1246" />
              <AIRecommendation text="Schedule post-event survey 24 hours after event" action="Schedule" data-id="element-1247" />
            </div>
          </div>

          {/* Attendee Insights */}
          <div className="bg-white rounded-2xl shadow-soft p-6 border border-slate-100" data-id="element-1248">
            <h2 className="text-lg font-bold text-brand-navy mb-6" data-id="element-1249">
              Attendee Insights
            </h2>

            <div className="space-y-6" data-id="element-1250">
              <div data-id="element-1251">
                <h3 className="text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2" data-id="element-1252">
                  <TargetIcon className="w-4 h-4 text-brand-teal" data-id="element-1253" /> Top Goals
                </h3>
                <div className="space-y-2" data-id="element-1254">
                  <InsightBar label="Communication" value={38} data-id="element-1255" />
                  <InsightBar label="Trust" value={32} data-id="element-1256" />
                  <InsightBar label="Energy" value={28} data-id="element-1257" />
                  <InsightBar label="Leadership" value={24} data-id="element-1258" />
                </div>
              </div>

              <div data-id="element-1259">
                <h3 className="text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2" data-id="element-1260">
                  <HeartPulseIcon className="w-4 h-4 text-brand-coral" data-id="element-1261" />{' '}
                  Wellness Preferences
                </h3>
                <div className="flex flex-wrap gap-2" data-id="element-1262">
                  <InsightChip label="Yoga" count={32} data-id="element-1263" />
                  <InsightChip label="Hike" count={28} data-id="element-1264" />
                  <InsightChip label="Spa" count={19} data-id="element-1265" />
                  <InsightChip label="Quiet time" count={14} data-id="element-1266" />
                </div>
              </div>

              <div data-id="element-1267">
                <h3 className="text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2" data-id="element-1268">
                  <UtensilsIcon className="w-4 h-4 text-brand-navy" data-id="element-1269" /> Dietary
                  Notes
                </h3>
                <div className="flex flex-wrap gap-2" data-id="element-1270">
                  <InsightChip label="Vegetarian" count={12} data-id="element-1271" />
                  <InsightChip label="GF" count={4} data-id="element-1272" />
                  <InsightChip label="Vegan" count={3} data-id="element-1273" />
                </div>
              </div>

              <div data-id="element-1274">
                <h3 className="text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2" data-id="element-1275">
                  <MessageSquareIcon className="w-4 h-4 text-brand-teal" data-id="element-1276" />{' '}
                  Comfort with Sharing
                </h3>
                <div className="flex items-center gap-3" data-id="element-1277">
                  <div className="flex-1 bg-slate-100 rounded-full h-2 relative" data-id="element-1278">
                    <div className="bg-brand-teal h-2 rounded-full w-[72%]" data-id="element-1279"></div>
                    <div className="absolute top-1/2 -translate-y-1/2 left-[72%] w-3 h-3 bg-brand-teal rounded-full border-2 border-white" data-id="element-1280"></div>
                  </div>
                  <span className="text-sm font-bold text-brand-navy" data-id="element-1281">7.2</span>
                </div>
                <div className="flex justify-between text-xs text-slate-400 mt-1" data-id="element-1282">
                  <span data-id="element-1283">Low</span>
                  <span data-id="element-1284">High</span>
                </div>
              </div>
            </div>
          </div>

          {/* Reporting Preview */}
          <div className="bg-white rounded-2xl shadow-soft p-6 border border-slate-100" data-id="element-1285">
            <div className="flex items-center justify-between mb-6" data-id="element-1286">
              <h2 className="text-lg font-bold text-brand-navy" data-id="element-1287">
                Reporting Preview
              </h2>
              <button className="text-brand-teal text-sm font-medium hover:underline flex items-center gap-1" data-id="element-1288">
                View Full Report <ExternalLinkIcon className="w-3 h-3" data-id="element-1289" />
              </button>
            </div>

            <div className="space-y-4" data-id="element-1290">
              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg" data-id="element-1291">
                <span className="text-sm text-slate-600" data-id="element-1292">Engagement</span>
                <span className="text-lg font-bold text-brand-navy" data-id="element-1293">78%</span>
              </div>

              <div className="p-3 bg-brand-navy/5 rounded-lg" data-id="element-1294">
                <div className="flex items-center justify-between mb-2" data-id="element-1295">
                  <span className="text-sm text-slate-600" data-id="element-1296">
                    Connection Score
                  </span>
                  <TrendingUpIcon className="w-4 h-4 text-brand-teal" data-id="element-1297" />
                </div>
                <div className="flex items-center gap-2 font-mono text-sm" data-id="element-1298">
                  <span className="text-slate-500" data-id="element-1299">6.4</span>
                  <span className="text-brand-teal" data-id="element-1300">→</span>
                  <span className="font-bold text-brand-navy" data-id="element-1301">8.1</span>
                </div>
              </div>

              <div data-id="element-1302">
                <div className="text-xs font-semibold text-slate-500 uppercase mb-2" data-id="element-1303">
                  Top Themes
                </div>
                <div className="flex flex-wrap gap-1.5" data-id="element-1304">
                  {['Alignment', 'Communication', 'Trust', 'Energy'].map(t => <span key={t} className="bg-slate-100 text-slate-600 text-xs px-2 py-1 rounded font-medium" data-id="element-1305">
                        {t}
                      </span>)}
                </div>
              </div>

              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg" data-id="element-1306">
                <span className="text-sm text-slate-600" data-id="element-1307">Commitments</span>
                <span className="text-lg font-bold text-brand-coral" data-id="element-1308">43</span>
              </div>

              <p className="text-xs text-slate-500 italic" data-id="element-1309">
                "Attendees reported stronger connection and clearer next steps."
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
// Helper Components
function MetricCard({
  icon,
  label,
  value,
  progress,
  color,
  status
}: any) {
  const colorMap: any = {
    teal: 'text-brand-teal',
    coral: 'text-brand-coral',
    navy: 'text-brand-navy'
  };
  const statusMap: any = {
    success: 'bg-emerald-50 text-emerald-700',
    warning: 'bg-amber-50 text-amber-700',
    info: 'bg-blue-50 text-blue-700'
  };
  return <div className="bg-white rounded-xl shadow-soft p-5 border border-slate-100" data-id="element-1310">
      <div className={`${colorMap[color] || 'text-slate-600'} mb-3`} data-id="element-1311">
        {icon}
      </div>
      <div className="text-xs text-slate-500 font-medium uppercase tracking-wider mb-2" data-id="element-1312">
        {label}
      </div>
      {status ? <span className={`inline-block text-xs font-bold px-2 py-1 rounded-full ${statusMap[status]}`} data-id="element-1313">
          {value}
        </span> : <>
          <div className="text-2xl font-black text-brand-navy mb-2" data-id="element-1314">
            {value}
          </div>
          {progress !== undefined && <div className="w-full bg-slate-100 rounded-full h-1.5" data-id="element-1315">
              <div className={`h-1.5 rounded-full ${color === 'coral' ? 'bg-brand-coral' : 'bg-brand-teal'}`} style={{
          width: `${progress}%`
        }} data-id="element-1316"></div>
            </div>}
        </>}
    </div>;
}
function ChecklistItem({
  label,
  completed,
  inProgress
}: any) {
  return <div className="flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 transition-colors" data-id="element-1317">
      <div className={`w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 ${completed ? 'bg-brand-teal border-brand-teal' : inProgress ? 'border-amber-400' : 'border-slate-300'}`} data-id="element-1318">
        {completed && <CheckCircle2Icon className="w-4 h-4 text-white" data-id="element-1319" />}
        {inProgress && <div className="w-2 h-2 bg-amber-400 rounded-full animate-pulse" data-id="element-1320"></div>}
      </div>
      <span className={`text-sm ${completed ? 'text-slate-400 line-through' : 'text-slate-700 font-medium'}`} data-id="element-1321">
        {label}
      </span>
    </div>;
}
function AgendaColumn({
  title,
  color,
  items
}: any) {
  const colorMap: any = {
    slate: 'border-slate-300',
    teal: 'border-brand-teal',
    coral: 'border-brand-coral',
    navy: 'border-brand-navy'
  };
  return <div className={`border-l-4 ${colorMap[color]} pl-4 space-y-3`} data-id="element-1322">
      <h3 className="font-bold text-sm text-brand-navy mb-4" data-id="element-1323">{title}</h3>
      {items.map((item: any, i: number) => <div key={i} className="text-xs" data-id="element-1324">
          {item.time && <div className="text-slate-500 font-medium mb-1" data-id="element-1325">{item.time}</div>}
          <div className="text-slate-700" data-id="element-1326">{item.label}</div>
        </div>)}
    </div>;
}
function ModuleCard({
  title,
  active,
  tags
}: any) {
  return <div className={`p-4 rounded-xl border-2 transition-all ${active ? 'border-brand-coral bg-brand-coral/5' : 'border-slate-100 bg-white hover:border-slate-200'}`} data-id="element-1327">
      <div className="flex items-start justify-between mb-3" data-id="element-1328">
        <h3 className="font-bold text-sm text-brand-navy" data-id="element-1329">{title}</h3>
        {active && <span className="bg-brand-coral text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-1330">
            Active
          </span>}
      </div>
      <div className="flex flex-wrap gap-1" data-id="element-1331">
        {tags.map((tag: string) => <span key={tag} className="bg-slate-100 text-slate-600 text-[10px] px-2 py-0.5 rounded font-medium" data-id="element-1332">
            {tag}
          </span>)}
      </div>
    </div>;
}
function GroupCard({
  title,
  count,
  avatars
}: any) {
  return <div className="bg-slate-50 p-4 rounded-xl border border-slate-100" data-id="element-1333">
      <h3 className="font-bold text-sm text-brand-navy mb-2" data-id="element-1334">{title}</h3>
      <p className="text-xs text-slate-600 mb-3" data-id="element-1335">{count}</p>
      <div className="flex -space-x-2" data-id="element-1336">
        {Array.from({
        length: avatars
      }).map((_, i) => <div key={i} className="w-7 h-7 rounded-full border-2 border-white bg-slate-200 overflow-hidden" data-id="element-1337">
            <img src={`https://i.pravatar.cc/100?img=${i + 20}`} alt="" className="w-full h-full object-cover" data-id="element-1338" />
          </div>)}
      </div>
    </div>;
}
function SurveyRow({
  title,
  status,
  statusColor
}: any) {
  const colorMap: any = {
    teal: 'bg-brand-teal/10 text-brand-teal',
    coral: 'bg-brand-coral/10 text-brand-coral',
    amber: 'bg-amber-50 text-amber-700',
    slate: 'bg-slate-100 text-slate-600'
  };
  return <div className="flex items-center justify-between p-3 rounded-lg hover:bg-slate-50 transition-colors" data-id="element-1339">
      <span className="text-sm text-slate-700 font-medium" data-id="element-1340">{title}</span>
      <span className={`text-xs font-bold px-2 py-1 rounded-full ${colorMap[statusColor]}`} data-id="element-1341">
        {status}
      </span>
    </div>;
}
function AIRecommendation({
  text,
  action
}: any) {
  return <div className="flex items-start justify-between gap-3 p-3 bg-white/5 rounded-lg border border-white/10 hover:bg-white/10 transition-colors" data-id="element-1342">
      <p className="text-sm text-slate-200 flex-1" data-id="element-1343">{text}</p>
      <button className="text-brand-coral text-xs font-bold hover:underline shrink-0" data-id="element-1344">
        {action}
      </button>
    </div>;
}
function InsightBar({
  label,
  value
}: any) {
  return <div data-id="element-1345">
      <div className="flex justify-between text-xs mb-1" data-id="element-1346">
        <span className="text-slate-600" data-id="element-1347">{label}</span>
        <span className="font-bold text-slate-700" data-id="element-1348">{value}%</span>
      </div>
      <div className="w-full bg-slate-100 rounded-full h-1.5" data-id="element-1349">
        <div className="bg-brand-teal h-1.5 rounded-full" style={{
        width: `${value}%`
      }} data-id="element-1350"></div>
      </div>
    </div>;
}
function InsightChip({
  label,
  count
}: any) {
  return <span className="bg-slate-100 text-slate-700 text-xs px-2.5 py-1 rounded-md font-medium" data-id="element-1351">
      {label} <span className="text-slate-500" data-id="element-1352">({count})</span>
    </span>;
}